import React from "react";
import { Input, Text } from "@flixbus/honeycomb-react";
import cx from "classnames";
import type { PlanningMonth } from "../../CostPanel.types";
import type { OpDataVariableOption } from "../../../../hooks/useOpDataCatalog";
import {
  cellFor,
  type OpDataVariableCells,
} from "../../../../hooks/resolveOpDataVariableValues";
import { formatNumber } from "@/utils/formatNumber";
import styles from "./InputsBody.module.scss";
import gridStyles from "./ReferencedOpDataGrid.module.scss";

export interface ReferencedOpDataGridProps {
  referencedOpDataVariables: OpDataVariableOption[];
  planningMonths: PlanningMonth[];
  values: OpDataVariableCells[];
}

// Reuses InputsBody's grid styles so the read-only rows line up with the editable ones.
const ReferencedOpDataGrid: React.FC<ReferencedOpDataGridProps> = ({
  referencedOpDataVariables,
  planningMonths,
  values,
}) => (
  <div className={styles.perMonthSection}>
    {referencedOpDataVariables.map((variable, rowIndex) => (
      <div key={variable.code} className={styles.perMonthRow}>
        <Text
          Elem="span"
          extraClasses={cx(styles.variableLabel, gridStyles.variableLabel)}
        >
          {variable.displayName}
        </Text>
        <div className={styles.monthInputs}>
          {planningMonths.map((month) => (
            <Input
              key={month.key}
              id={`sysvar_${variable.code}_${month.key}`}
              label={rowIndex === 0 ? month.label : ""}
              aria-label={`${variable.displayName} ${month.label}`}
              type="text"
              value={formatNumber(cellFor(values, variable.code, month.key))}
              extraClasses={styles.monthInput}
              readOnly
              disabled
            />
          ))}
        </div>
      </div>
    ))}
  </div>
);

export default React.memo(ReferencedOpDataGrid);
